module.exports = __webpack_public_path__ + "img/marker_default.8390a735.svg";